import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom"
import { roundUp } from '../functions/functions';
import FlatListItem from "./FlatListItem";
import PlaceSearch from './PlaceSearch';
import { FiSearch } from 'react-icons/fi';

import { db, auth } from '../functions/firebaseFunctions'

  
export default function SearchservicesTab() {
    const [serviceCounts, setServiceCounts] = useState(0);
    const [Err, setErr] = useState(null);
    const [services, setServices] = useState(null);
    const [found, setFound] = useState(null);
    
    useEffect(() => {
        //get the list of services
        db.collection('services')
          .get().then(Artists => {
            if (!Artists.empty) {
              //if there are Artist
              let arr = []; //create and empty array
              let countServices = 0;
              Artists.docs.map(Artist => {
                //for each Artist
                let serviceData = Artist.data();
                //get the artist info from the user
                db.collection('users').doc(serviceData.uid)
                  .get().then((user) => {
                    if (user.exists && user.data()?.mobile_pay_activation) {
                      let userData = user.data();
      
                      serviceData.services.map(service => {
                        //get data for each service of that artist
                        db.collection('ratings').doc('services').collection(serviceData.uid)
                          .where('type', '==', service.servicetype)
                          .get().then((r) => {
                            let Rqty = 0;
                            let offset = 0;
      
                            if (!r.empty) {
                              let Rsum = 0;
                              r.docs.map(rat => {
                                let val = rat.data();
                                Rsum = Rsum + val.rating;
                                Rqty = Rqty + 1;
      
                              });
                              let rat = roundUp(Rsum / Rqty, 0.1);
                              offset = rat / 5;
      
                            }
                            const photo = userData.photo;
                            const name = userData.name;
                            arr.push({
                              uid: serviceData.uid,
                              type: service.servicetype,
                              price: service.price,
                              name: name,
                              photo: photo,
                              qty: Rqty, offset: offset,
                            }
                            );
                            countServices++;
                            setServiceCounts(countServices);
                            setServices(arr);
                          }).catch(e => { setErr(e); console.log('err', e) });
                      });
                    }
                  });
              });
            }
          }).catch(e => { setErr(e); console.log('err', e) });;
    }, []);
    
  const searchIn = async event => {
    event.preventDefault();
    const searchInput = document.querySelector('#search');
    const search = searchInput.value.toLowerCase();
    console.log('input:', search);
  
    // Используем регулярное выражение для создания шаблона с поиском неполных совпадений и с ошибками
    const searchPattern = `.*${search.split('').map(char => `[${char}]`).join('.*')}.*`;
  
    // Получаем все документы из коллекции 'users'
    db.collection('users')
      .get()
      .then(querySnapshot => {
        const foundUsers = querySnapshot.docs.map(doc => doc.data())
          .filter(service => {
            if (service && service.name) {
              const servName = service.name.toLowerCase();
              return new RegExp(searchPattern, 'i').test(servName);
            }
            return false; // или другая обработка случая, когда service или service.name равны undefined
          });
  
        // Фильтруем массив services по параметру uid
        const filteredServices = services.filter(service => foundUsers.some(foundService => foundService.uid === service.uid));
  
        // Помещаем найденные совпадения в состояние (state), которое будет отображаться пользователю
        setFound(filteredServices);
        console.log('Found items:', filteredServices);
      })
      .catch(error => {
        console.error('Error getting documents:', error);
      });
  };
    return(
        <>
            <div style={{width: '100%',  display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
            <form onSubmit={searchIn}  className='browseForm'>
                <label htmlFor="search" className="label" style={{width: '100%', }}>
                Search artist
                <input 
                    style={{marginInlineStart: 5}}
                    name='search'
                    id='search'
                    type='text'
                    // style={{ paddingVertical: 0 }}
                    // autocompletetype="off"
                    placeholder= "Enter artist name"
                />
                </label>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center'}}>
                <button 
                    style={{
                    color: "var(--wht)",
                    alignSelf: 'center',
                    borderWidth: 0,
                    justifyContent: 'center',
                    alignContent: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifySelf: 'center',
                    // marginBlockStart: 10,
                    }}
                    color="white"
                    type='submit'
                >
                    <FiSearch style={{marginInline: 5, fontSize: 24}} className=''/>
                </button>
                </div>
            </form>
            <div className='browsePannel'>
                {found &&
                found.map(service =>
                    <Link to={`/artist/${service.uid}&${service.type}`} style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', cursor: 'pointer', }}>
                    {console.log(service)}
                    <FlatListItem key={service.uid + service.type} item={service} type="service"
                        onClick={() => console.log(service)} />
                    </Link>
                )}
            </div>
            </div>
        </>
    )
}